// extracted by mini-css-extract-plugin
export default {"container_footer":"Footer_container_footer__Ylbh3","footer_wrapper":"Footer_footer_wrapper__l6dgp","text":"Footer_text__4fajo"};